module.exports = __webpack_public_path__ + "img/2-8463.e0898223.png";